module.exports = __webpack_public_path__ + "static/media/file-icon.fe81ad2e.svg";